/* eslint-disable */

import { Box, DialogContent, Grid, IconButton, Typography, Link } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
import React, { useState, useEffect, useRef } from "react";
import { GlobalTheme } from "../../themes/GlobalTheme";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import UserMenu from "../Account/UserMenu";
import SearchBar from "../Widgets/SearchBar";
import LanguageSelector from "../Widgets/LanguageSelector";
import TreeMenu from "../Widgets/TreeMenu";
import PrefsMenu from "../Widgets/PrefsMenu";
import { ContentViewport, DialogActionsForm } from "../Widgets/CustomSurfaces";
import MenuRouter, { possibleNodePaths } from "../../routers/MenuRouter";
import SelectURL from "../Widgets/Custom Inputs/Select";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadTranslations } from "../../js/redux/actions/i18n";
import translations from "../../l10n/translations";
import {
    updateDifferentEntitySelected,
    updateEntityTree,
    updateTreeViewNodeExpand,
    updateNavigationPath,
} from "../../js/redux/actions/userPref";
import { OTAppBar } from "../Widgets/AppBar";
import { historyPush } from "../../js/utils/genericMethods";
import { BasicTooltip } from "../Widgets/StyledComponents";
import { t } from "react-i18nify";
import { DrawerOpener } from "./CommonLayout";
import NotificationMenu from "../Account/NotificationMenu";
import { fetchTraverseExtendTreePathNodes } from "../TreeEditors/EntityTree";
import { Dialog } from "@mui/material";
import { BasicButton } from "../Widgets/Custom Inputs/Buttons";
import Axios from "axios";
import * as r from "../../js/constants/routes";
import { hideNewFeaturesPopUp } from "../../js/redux/actions/auth";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Link as RouterLink } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VersionJSON from "../../common/sharedSettings.json";
import { fetchNewEntityTreeView } from "../../js/utils/backend";
import { isEntityNavigationPage, useNavigationPathHistory } from "../../js/utils/useNavigationPathHistory";
import { localizeNavigationPath } from "../../js/utils/navigationPath";

const version = VersionJSON.Version;


const MainLayout = () => {
    const maxNumberOfCharacters = 10;
    const appBarRef = useRef(null);
    const [treeMenuOpen, setTreeMenuOpen] = useState(true);
    const [newEntityTreeView, setNewEntityTreeView] = useState(false);
    const [tree, setTree] = useState([]);
    const entity = useSelector(state => state.userPref.CurrentEntity);
    const navPath = useSelector(state => state.userPref.NavigationPath);
    useNavigationPathHistory();
    const history = useHistory();
    const dispatch = useDispatch();
    const handleTreeMenuOpen = () => {
        setTreeMenuOpen(true);
    };
    const handleTreeMenuClose = () => {
        setTreeMenuOpen(false);
    };
    const locale = useSelector(state => state.i18n.locale);
    const token = useSelector(state => state.auth.Token);
    
    const [features, setFeatures] = useState(null);
    const [prefsMenuOpen, setPrefsMenuOpen] = useState(false);
    const handlePrefsMenuClick = () => {
        setPrefsMenuOpen(!prefsMenuOpen);
    };
    const handlePrefsMenuClose = () => {
        setPrefsMenuOpen(false);
    };

    const [language, setLanguage] = useState();

    useEffect(() => {
        if (language) {
            dispatch(loadTranslations(translations));
        }
    }, [dispatch, language]);

    useEffect(() => {
        setLanguage(locale);
        dispatch(updateEntityTree());
    }, [locale, dispatch]);

    useEffect(() => {
        const updatedNavPath = localizeNavigationPath(navPath, locale);
        if (updatedNavPath !== navPath) {
            dispatch(updateNavigationPath(updatedNavPath));
            localStorage.setItem("navigationPath", JSON.stringify(updatedNavPath));
        }
    }, [navPath, locale, dispatch]);
    
    useEffect(() => {
        if(entity && isEntityNavigationPage(history.location.pathname)){
            const path = localStorage.getItem("navigationPath");
            const navPathArray = JSON.parse(path ?? "[]");
            if(navPathArray.length === 0){
                const newPath = [{
                    path: entity.Name,
                    url: `/entity-page/${entity.ObjectID}`,
                    parentValue: "",
                    translations: null,
                    englishValue: "",
                }];
                dispatch(updateNavigationPath(newPath));
                localStorage.setItem("navigationPath", JSON.stringify(newPath));
            }
            else{
                dispatch(updateNavigationPath(navPathArray));
                localStorage.setItem("navigationPath", JSON.stringify(navPathArray));
            }
        }
    }, [entity, dispatch, history])

    useEffect(() => {
        const url = "OTEntity/getSearchSubMenuEntities";
        const config = {
            headers: { Authorization: "Bearer " + token }
        };
        const fetchData = async () => {
            await fetchNewEntityTreeView(token).then(result => {
            setNewEntityTreeView(result.data);
            Axios.post(url, [], config).then(response => {
                if(result.data){
                    setTree(response.data);
                }
            })
        })};
        fetchData();
    }, [token]);

    const newTreeViewExpand = (entityID) => {
        for(let i=0; i<tree.length; i++){
            for(let j=0; j<tree[i].Countries.length; j++){
                for(let k=0; k<tree[i].Countries[j].OTEntities.length; k++){
                    if(tree[i].Countries[j].OTEntities[k].Value === entityID){
                        const element1 = `${tree[i]?.BranchID}:${tree[i]?.Countries[j]?.OTEntities[k]?.Value}`;
                        const element2 = `${tree[i]?.BranchID}:${tree[i]?.Countries[j]?.CountryID}`;
                        const element3 = tree[i]?.BranchID;
                        return [element1, element2, element3];
                    }
                }
            }
        }
    }

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            if(newEntityTreeView){
                const nodes = newTreeViewExpand(entity?.ObjectID);
                if(nodes){
                    dispatch(updateTreeViewNodeExpand(newTreeViewExpand(entity?.ObjectID)));
                }
            }
            else{
                dispatch(updateTreeViewNodeExpand([entity?.ObjectID]));
            }
        }
        // eslint-disable-next-line
    }, [entity, dispatch]);

    const onChangeEntitySelection = async (_event, data) => {
        if(newEntityTreeView){
            dispatch(updateDifferentEntitySelected(true));
            dispatch(updateTreeViewNodeExpand(newTreeViewExpand(data.ObjectID)));
        }
        else{
            dispatch(updateTreeViewNodeExpand([data.ObjectID]));
        }
        const entityUrl = `/entity-page/${data.ObjectID}`;
        await historyPush(history, entityUrl);
        if (history.location.pathname === entityUrl) {
            const newPath = [{
                path: data.Name,
                url: entityUrl,
                parentValue: "",
                translations: null,
                englishValue: "",
            }];
            dispatch(updateNavigationPath(newPath));
            localStorage.setItem("navigationPath", JSON.stringify(newPath));
        }
    };

        ////////////////////////////////// PROGRAMMATIC NODES EXPANSION \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
    /** Attempt to match current route with a list of routes containing a node id (in order to open treemenu to that specific node. */
    const isConnected = useSelector(state => state.auth.IsConnected);
    const userId = useSelector(state => state.auth.UserID);
    const isExternalUser = useSelector(state => state.auth.External);
    const [displayNewFeaturesPopUp,setDisplayNewFeaturesPopUp] = useState(useSelector(state => state.auth.DisplayNewFeaturesPopUp));
    const [lastNewFeaturesPopupOpen, setLastNewFeaturesPopupOpen] = useState(useSelector(state => state.auth.LastNewFeaturesPopupOpen));
    //const lastNewFeaturesPopupOpen = useSelector(state => state.auth.LastNewFeaturesPopupOpen);
    //const latestVersionNumber = useSelector(state => state.auth.Version);
    const match = useRouteMatch(possibleNodePaths?.map(e => e))
    const location = useLocation();
    const config = {
        headers: {
            Authorization: "Bearer " + token,
        },
    };
    
    useEffect(() => {
        let config = {
            headers: { Authorization: "Bearer " + token },
        };
        const fetching = async () => {
            const response = await Axios.get(`NewFeaturesMessage?LastNewFeaturesPopupOpen=${lastNewFeaturesPopupOpen}&orderBy=CreatedOn`, config);
            setFeatures(response.data.Data);
        }
        fetching();
    }, [token,lastNewFeaturesPopupOpen]);

    useEffect(() => {
        let isSubscribed = true
        if (isSubscribed && isConnected) {
            let isWorkOrder = match?.params?.GenericGridTypeParent === "WorkOrder"
            let isStationGroup = match?.params?.elementType === "StationGroup"
            let isQueryViewReporting = match?.params?.GenericGridTypeParent === "query-view-reporting"
            // external tree should be a custom other func; 'WorkOrder', 'StationGroup', 'query-view-reporting' are specific nodes to handle (need to get an nodeID from the three to retrieve all otentitytreepath)
            if (isExternalUser || isWorkOrder || isStationGroup || isQueryViewReporting ) {
                return null 
            } else if (!isExternalUser && match?.params?.nodeID) {
                if (match.params.GenericGridTypeParent === "Study") {
                    fetchTraverseExtendTreePathNodes(match?.params?.nodeID, token, dispatch, "otentitystudypath")
                } else {
                    fetchTraverseExtendTreePathNodes(match?.params?.nodeID, token, dispatch)
                }
            }
        }
        return () => (isSubscribed = false);
        // eslint-disable-next-line
    }, [location])
    //////////////////////////////////  PROGRAMMATIC NODES EXPANSION  \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

    return (
        <ThemeProvider theme={GlobalTheme}>
            <OTAppBar
                ref={appBarRef}
                UpperAppBar={
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            ml: { xs: 2 },
                        }}
                    >
                        <Box sx={{ typography: "body2", mr: 2 }}>
                        v. {version}
                        </Box>
                        <LanguageSelector />
                        <UserMenu username={null} />
                        <NotificationMenu />
                        <Box>
                            <BasicTooltip title={t("common.SettingsPanel")}>
                                <IconButton
                                    color="inherit"
                                    aria-label="open right or prefs menu drawer"
                                    onClick={handlePrefsMenuClick}
                                    edge="start"
                                    sx={{
                                        mr: 1,
                                    }}
                                >
                                    <SettingsIcon />
                                </IconButton>
                            </BasicTooltip>
                        </Box>
                    </Box>
                }
                LowerAppBar={
                    <Box>
                    <Box
                        sx={{
                            width: 1,
                            height: 60,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Box sx={{ width: 300, mx: 1 }}>
                            <SelectURL
                                variant="standard"
                                value={entity}
                                URL={"OTEntity"}
                                getOptionLabel={option => option.Name ?? ""}
                                onChange={(event, data) =>
                                    onChangeEntitySelection(event, data)
                                }
                                isOptionEqualToValue={(option, value) =>
                                    option.ObjectID === value.ObjectID
                                }
                                disableClearable
                            />
                        </Box>
                        <Grid item sx={{ flexGrow: 1 }} />
                        <HelpOutlineIcon sx={{ typography:"subtitleMajor", marginRight:"2px" }} />
                        <Link component={RouterLink} to="/help" sx={{ marginBottom:"2px", typography:"body1", textDecoration:"none", mr:3}}>
                            <strong>{t("common.Help")}</strong>
                        </Link>
                        <SearchBar />
                    </Box>
                    <Box sx={{ typography:"body2", mb:1, display: "flex", flexWrap: "wrap", alignItems: "center", overflow: "hidden", width: "70%", wordBreak: "break-word" }}>
                        {navPath && navPath.length > 0 && navPath.map((item, idx) => {
                            const isTruncated = Boolean(item.path) && item.path.length > maxNumberOfCharacters;
                            const label = isTruncated
                                ? item.path.slice(0, maxNumberOfCharacters) + "..."
                                : item.path;
                            const withTooltip = element => isTruncated
                                ? <BasicTooltip title={item.path}>{element}</BasicTooltip>
                                : element;
                            return (
                            <span key={idx} style={{ display: "flex", alignItems: "center" }}>
                                {idx > 0 && (
                                    <span style={{ color:"red", fontWeight:"bold", margin:"0 4px" }}>{">"}</span>
                                )}
                                {item.url && item.url !== "" ? withTooltip(
                                    <Link
                                        component={RouterLink}
                                        to={item.url}
                                        sx={{
                                            color: "body2",
                                            cursor: "pointer",
                                            textDecoration: "none",
                                            whiteSpace: "nowrap",
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}
                                        onClick={() => {
                                            const updatedPath = navPath.slice(0, idx + 1);
                                            dispatch(updateNavigationPath(updatedPath));
                                            localStorage.setItem("navigationPath", JSON.stringify(updatedPath));
                                        }}
                                    >
                                        {label}
                                    </Link>
                                ) : withTooltip(
                                    <span style={{ whiteSpace: "nowrap", marginRight: 2 }}>
                                        {label}
                                    </span>
                                )}
                            </span>
                            );
                        })}
                    </Box>
                </Box>
                }
            />
            {displayNewFeaturesPopUp ? (<Dialog open={Boolean(displayNewFeaturesPopUp)} fullWidth="lg" maxWidth>
                <DialogContent>
                    {features && ((locale === 'ENG') &&
                        (<><Typography>
                            <Box sx={{ typography: "bodyMajor" }}>{t("common.featuresmessage")}</Box><br />
                        </Typography>
                            </>
                        ))}
                    {features && ((locale === 'FRA') &&
                        (<><Typography>
                            <Box sx={{ typography: "bodyMajor" }}>{t("common.featuresmessage")}</Box><br />
                        </Typography>
                            </>
                        ))}

                    {features && (
                        <div>
                            {features?.map((item) => (
                                <Accordion key={item.ID}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls={`panel${item.ID}-content`}
                                        id={`panel${item.ID}-header`}
                                    >
                                        <Typography component="span" style={{ color: 'red', fontWeight: 'bold' }}>
                                            {locale === 'ENG' && 'Version '}
                                            {locale === 'FRA' && 'Version '}
                                            {locale === 'NLD' && 'versie '}
                                            {locale === 'DEU' && 'Version '}
                                            {locale === 'SPA' && 'versión '}
                                            {locale === 'POR' && 'versão '}
                                            {item.VersionNumber}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            {locale === 'ENG' && (<ul><li>{item.Translations?.ENG}</li></ul>)}
                                            {locale === 'FRA' && (<ul><li>{item.Translations?.FRA===undefined ? item.Translations?.ENG : item.Translations?.FRA}</li> </ul>)}
                                            {locale === 'NLD' && (<ul><li>{item.Translations?.NLD===undefined ? item.Translations?.ENG : item.Translations?.NLD}</li></ul>)}
                                            {locale === 'DEU' && (<ul><li>{item.Translations?.DEU===undefined ? item.Translations?.ENG : item.Translations?.DEU}</li> </ul>)}
                                            {locale === 'SPA' && (<ul><li>{item.Translations?.SPA===undefined ? item.Translations?.ENG : item.Translations?.SPA}</li></ul>)}
                                            {locale === 'POR' && (<ul><li>{item.Translations?.POR===undefined ? item.Translations?.ENG : item.Translations?.POR}</li> </ul>)}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </div>
                    )}

                </DialogContent>
                <DialogActionsForm>
                    <BasicButton
                        type="button"
                        style={{
                            position: "relative",
                            margin: 4,
                        }}
                        onClick={async () => {
                            var response = await Axios.post(
                                `${r.oTUser}/DisableNewFeaturesPopUp/${userId}`,
                                {},
                                config);
                            if(response!==null){
                                setDisplayNewFeaturesPopUp(false);
                                setLastNewFeaturesPopupOpen(new Date());
                                dispatch(hideNewFeaturesPopUp());
                            }
                        }}
                    >
                        {t("common.Close")}
                    </BasicButton>
                </DialogActionsForm>
            </Dialog>) : null}
            <DrawerOpener
                treeMenuOpen={treeMenuOpen}
                handleTreeMenuClose={handleTreeMenuClose}
                handleTreeMenuOpen={handleTreeMenuOpen}
                appBarRef={appBarRef}
            />

            {/* Left drawer display the business tree view, with favs. DOC*/}
            <TreeMenu
                handleTreeMenuClose={handleTreeMenuClose}
                treeMenuOpen={treeMenuOpen}
            />
            {/* Right drawer display the app settings and user prefs. DOC*/}
            <PrefsMenu
                handlePrefsMenuClose={handlePrefsMenuClose}
                prefsMenuOpen={prefsMenuOpen}
            />
            <ContentViewport
                treeMenuOpen={treeMenuOpen}
                prefsMenuOpen={prefsMenuOpen}
                appBarRef={appBarRef}
            >
                {/* Rendering & route-based content */}
                <MenuRouter />
            </ContentViewport>
        </ThemeProvider>
    );
};

export default MainLayout;
